<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedit">With gratitude to my parents,</p>
<p class="dedi">the late Derrick and Joyce Coby,</p>
<p class="dedi">and to my wife,</p>
<p class="dedi">Sally Blandford</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?3652d081